import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";

import { 
  ModelBase,
} from "@models";
import { 
  GameDeck, 
} from "@dndModels";

import API from "@dndUtilities/system_api";
import CommonUtilities from "@utilities/common_utilities";

import ModelBaseInput from "@dndComponents/ModelBaseInput";
import LoadingBox from "@components/input/LoadingBox";

const api = API.getInstance();
const common_util = CommonUtilities.getInstance();

export default function GameDeckEdit() {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [fetched, setFetched] = useState(false);
  const [reloading, setReloading] = useState(false);
  const [obj, setObj] = useState<GameDeck>(api.applyWorkingOn(new GameDeck()));
  const [change_time, setChangeTime] = useState(0);
  
  const disabled = api.user === null || !api.online || (!api.user.admin && obj._id !== "" && obj.owner_id !== api.user._id);
  
  useEffect(() => {
    if(!fetched) {
      load();
    }
  });
    
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  const load = () => {
    setFetched(true);
    // debugger;
    if (id && id !== "") {
      load_object(id);
    } else {
      // It's here from clicking Create on index.  
      // If the user is not admin, then we need to give the floating feature their id as owner or it will be disabled.
      const new_obj = obj;
      if (api.user && !api.user.admin && new_obj.name === "" && new_obj.owner_id === "") {
        new_obj.owner_id = api.user._id;
      }
      setObj(new_obj);
    }
  }

  // Loads the editing Creature into state
  const load_object = (id: string) => {
    setLoading(true);
    api.getFullObject("game_deck", id).then(res => {
      if (res instanceof GameDeck) {
        setObj(res);
        setLoading(false);
      }
    });
  }

  // const submit = () => {
  //   if (api.user && 
  //     (api.user.admin || 
  //       obj._id === "" || 
  //       obj.owner_id === api.user._id)) {
  //     setProcessing(true);
  //     if (!api.user.admin || obj.source_books_old.filter(o => o.id === "Personal").length > 0) {
  //       obj.owner_id = api.user._id;
  //     } else if (api.user.admin && obj.source_books_old.filter(o => o.type === "Homebrew").length === 0) {
  //       obj.owner_id = "";
  //     }
  //     api.upsertObject("game_deck", obj).then(res => {
  //       console.log(res);
  //       if (res && res.body.id) {
  //         obj._id = res.body.id;
  //       }
  //       setProcessing(false);
  //       setNavigateTo("/dandd/game_deck");
  //     });
  //   }
  // }
  
  const height = window.innerHeight - 64;
  if (!fetched || loading) {
    return (<LoadingBox size={height * 0.5} height={height} width={window.innerWidth} />);
  } else {
    return (
      <ModelBaseInput
        obj={obj}
        disabled={disabled}
        change_time={change_time}
        onChange={(changed: ModelBase) => {
          if (changed instanceof GameDeck) {
            const new_obj = obj;
            new_obj.copy(changed);
            setObj(new_obj);
            setChangeTime(common_util.get_time_number());
          }
        }}
      />
    );
  }
}